class Storage {
  getSessionData() {
    let user = {};
    let session = {};
    try {
      user = JSON.parse(localStorage.getItem('user'));
      session = JSON.parse(localStorage.getItem('session'));
    } catch(e) {
      console.log(e);
    }

    return {
      user: user || {},
      session: session || {}
    }
  }

  getJoinWebinarId() {
    let joinWebinarId = null;
    joinWebinarId = localStorage.getItem('joinWebinarId');
    return joinWebinarId;
  }

  setJoinWebinarId(id) {
    localStorage.setItem('joinWebinarId', id);
  }

  removeJoinWebinarId() {
    localStorage.removeItem('joinWebinarId')
  }

  setSessionData(user = {}, session = {}) {
    this.purgeSessionData();
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('session', JSON.stringify(session));
  }

  purgeSessionData() {
    localStorage.setItem('user', JSON.stringify({}));
    localStorage.setItem('session', JSON.stringify({}));
    return true;
  }
}

export default (new Storage());



/** WEBPACK FOOTER **
 ** ./src/services/storage.js
 **/